import type { CommunicationType } from '@/dto/communications/communication-details.dto';
import type { ValueOf } from 'type-fest';

export const LEGACY_MODE_OF_SEND = {
  EMAIL: 'email',
  EMAIL_CONDOMINIALE: 'email-condominiale',
  CORRISPONDENZA_AL: 'corrispondenza-al',
  CORRISPONDENZA: 'corrispondenza',
  POSTA_1_ORDINARIA: 'posta1-ordinaria',
  POSTA_4_ORDINARIA: 'posta4-prioritaria',
  RACCOMANDATA: 'raccomandata',
  RACCOMANDATA_1: 'raccomandata-1',
  RACCOMANDATA_AR: 'raccomandata-ar',
  RACCOMANDATA_AR_1: 'raccomandata-ar-1',
  RACCOMANDATA_SPID: 'raccomandata-spid',
  PEC: 'pec',
} as const;

export type LegacyModeOfSend = ValueOf<typeof LEGACY_MODE_OF_SEND>;

export type ModesOfSendDTO = {
  communicationType: CommunicationType;
  modeOfSend: LegacyModeOfSend;
  requirePrint: boolean;
  label: string;
  enabled: boolean;
  description_usr: string | undefined;
};
